// src/app/shared/services/canonical.service.ts
import { Injectable, Inject, Renderer2, RendererFactory2 } from "@angular/core";
import { DOCUMENT } from "@angular/common";

@Injectable({ providedIn: "root" })
export class CanonicalService {
  private _renderer: Renderer2;

  constructor(
    @Inject(DOCUMENT) private _doc: Document,
    private _rendererFactory: RendererFactory2,
  ) {
    this._renderer = this._rendererFactory.createRenderer(null, null);
  }

  public setCanonicalAndHreflangs(currentLang: string): void {
    const baseUrl: string = "https://brightfunded.com";
    const supportedLangs: string[] = ["en", "es", "de", "pl"];

    const currentUrl: string =
      currentLang === "default" ? `${baseUrl}/` : `${baseUrl}/${currentLang}/`;

    this._removeLink("canonical");

    const canonical = this._renderer.createElement("link");
    canonical.setAttribute("rel", "canonical");
    canonical.setAttribute("href", currentUrl);
    this._renderer.appendChild(this._doc.head, canonical);

    this._removeLinks("alternate");

    supportedLangs.forEach((lang) => {
      const alt = this._renderer.createElement("link");
      alt.setAttribute("rel", "alternate");
      alt.setAttribute("hreflang", lang);
      alt.setAttribute("href", `${baseUrl}/${lang}/`);
      this._renderer.appendChild(this._doc.head, alt);
    });

    const xDefault = this._renderer.createElement("link");
    xDefault.setAttribute("rel", "alternate");
    xDefault.setAttribute("hreflang", "x-default");
    xDefault.setAttribute("href", `${baseUrl}/`);
    this._renderer.appendChild(this._doc.head, xDefault);
  }

  private _removeLink(rel: string): void {
    const element: Element | null = this._doc.querySelector(`link[rel='${rel}']`);
    if (element) {
      this._renderer.removeChild(this._doc.head, element);
    }
  }

  private _removeLinks(rel: string): void {
    const elements: NodeListOf<Element> = this._doc.querySelectorAll(`link[rel='${rel}']`);
    elements.forEach((el) => {
      this._renderer.removeChild(this._doc.head, el);
    });
  }
}
